export default {
  login: {
    name1: 'Welcome to ListekIOT MS',
    name2: 'Pls enter your email Add',
    name3: 'Pls input a password',
    name4: 'Pls enter the Verif code',
    name5: 'REM me',
    name6: 'Forgot PWD?',
    name7: 'Login',
    name8: 'Get demo account',
    name9: 'Return to official version',
    name10: 'Register  trial version',
    name11: 'Lishui Electronic Research Institute @ 2025 Listek',
    name12: 'Log in ListekIOT trial version',
    name13: 'Demo Account',
    name14: 'Account name',
    name15: 'Demo website ',
    name16: 'Account',
    name17: 'Password',
    name18: 'One click login',
    name19: 'Login Now',
    name20: 'Account:',
    name21: 'Password:',
    name22: 'Forgot PWD'
  },

  register: {
    name1: 'Return to official version',
    name2: 'Register ListekIOK trial version',
    name3: 'Pls enter the company name',
    name4: 'Pls enter your email Add',
    name5: 'Pls enter the Verif code',
    name6: 'Obtain Verif code',
    name7: 'Pls input a PWD',
    name8: 'Enter PWD again',
    name9: 'Read',
    name10: 'Privacy Policy',
    name11: 'Register Now',
    name12: 'Existing account, login now',
    name13: 'Lishui Electronic Research Institute @ 2025 Listek'
  },

  retrievePassword: {
    name1: 'Return',
    name2: 'Find PWD',
    name3: 'Pls enter your email',
    name4: 'Pls enter the  Verif code',
    name5: 'Obtain Verif code',
    name6: 'Pls input a PWD',
    name7: 'Enter PWD again',
    name8: 'Submit',
    name9: 'Get demo account',
    name10: 'Lishui Electronic Research Institute @ 2025 Listek',
    name11: 'Pls enter your phone no',
    name12: 'Send Verif code',
    name13: 'Resend',
    name14: 'Pls enter your password again',
    name15: 'The password entered twice is inconsistent!',
    name16: 'The format of the phone number is incorrect',
    name17: 'Pls enter email format',
    name18: 'Email format incorrect',
    name19: 'Pls enter a password of at least 6 characters',
    name20: 'The password must contain both numbers and letters'
  },

  tabmenu: {
    name1: 'Home',
    name2: 'Vehicle',
    name3: 'Upgrade',
    name4: 'Historical Vis. report',
    name5: 'Wired Upgrade Tool',
    name6: 'OTA MGT',
    name7: 'Vehicle MGT',
    name8: 'Vehicle List',
    name9: 'Model List',
    name10: 'Firmware Upgrade Record',
    name11: 'Fault MGT',
    name12: 'Finance',
    name13: 'IOT Device Charging',
    name14: 'SIM Card MGT',
    name15: 'Operate',
    name16: 'App Operate',
    name17: 'List Overview',
    name18: 'Users Overview',
    name19: 'Manage',
    name20: 'System MGT',
    name21: 'System User List',
    name22: 'System User Roles',
    name23: 'Rules Competency',
    name24: 'System Log MGT',
    name25: 'Manufacturer MGT',
    name26: 'Manufacturers List',
    name27: 'Manufacturer User List',
    name28: 'Merchant MGT',
    name29: 'Merchant List',
    name30: 'Merchant User List',
    name31: 'Franchisees List',
    name32: 'Franchise User List',
    name33: 'System notification',
    name34: 'Setting',
    name35: 'Purview',
    name36: 'Manufacturer User Roles',
    name37: 'Merchant User Roles',
    name38: 'Cycling List',
    name39: 'Roadbook List',
    name40: 'Cycling MGT',
    name41: 'IOT List',
    name42: 'Feedback List',
    name43: 'Vehicle Purchase Order',
    name44: 'Three Types Merchant Sys Intro.',
    name45: 'Push List',
    name46: 'Franchisees User Roles',
    name47: 'Visual Report',
    name48: 'Vehicle Analysis',
    name49: 'Data Screening',
    name50: 'Activate Data',
    name51: 'Report Details',
    name52: 'Electronic Fence',
    name53: 'Vehicle Operations',
    name54: 'Reconciliation',
    name55: 'Batch Upgrade',
    name56: 'Real time monitoring',
    name57: 'Usage',
    name58: 'Fault statistics',
    name59: 'Regional Dist.',
    name60: 'App configuration',
    name61: 'Transaction record',
    name62: 'Refund record',
    name63: 'Data Summary',
    name64: 'App Analysis',
    name65: 'App Situation',
    name66: 'Product QC',
    name67: 'Model Summary ',
    name68: 'Maintenance Record',
    name69: 'Sales Record',
    name70: 'Sys Configuration MGT',
    name71: 'Demo Account MGT',
    name72: 'Manufacturer customer service Cfg.'
  },

  home: {
    name1: 'View Details',
    name2: 'Manufacturers No.',
    name3: 'IOT Merchants No.',
    name4: 'Merchants No.',
    name5: 'IOT Accumulated Charges',
    name6: 'Households',
    name7: 'Trend of IoT device additions',
    name8: 'Fault situation',
    name9: 'Fault handling situation',
    name10: 'SIM card usage',
    name11: 'Accumulated QTY of IOT/pcs',
    name12: 'New additions this month',
    name13: 'Accumulated activation quantity/pcs',
    name14: 'Accumulated no. of faults/pcs',
    name15: 'Accumulated data usage on SIM card/M',
    name16: 'Cumulative no. of manufacturers/household',
    name17: 'Accumulated no. of merchants/household',
    name18: 'New QTY of IOT',
    name19: 'No. of IoT activations',
    name20: 'TOP 5 Manufacturer',
    name21: 'Manufacturer/Merchant',
    name22: 'TOP 5 Merchant',
    name23: 'All vehicles',
    name24: 'Online vehicles',
    name25: 'Faulty vehicle',
    name26: 'QTY of electricity',
    name27: 'Vehicle status',
    name28: 'Unlocked',
    name29: 'Locked',
    name30: 'In use',
    name31: 'Account info.',
    name32: 'Change PWD',
    name33: 'Account ownership:',
    name34: 'This login:',
    name35: 'Login region:',
    name36: 'Last login:',
    name37: 'Original PWD:',
    name38: 'Too high temperature',
    name39: 'Total number of users',
    name40: 'Total number of online users on the app',
    name41: 'Total number of offline users on the app',
    name42: 'Latest registered app users'
  },
  bike: {
    name1: 'Manufacturer name:',
    name2: 'Vehicle model no.:',
    name3: 'Add vehicle',
    name4: 'Vehicle model no.',
    name5: 'Manufacturer name',
    name6: 'Report time',
    name7: 'Speed',
    name8: 'Height',
    name9: 'Controller voltage',
    name10: 'Controller current',
    name11: 'Operation',
    name12: 'Inspect',
    name13: 'Delete',
    name14: 'Controller',
    name15: 'Show',
    name16: 'Battery',
    name17: 'Port no.:',
    name18: 'File name:',
    name19: 'Upgrade Now',
    name20: 'Type:',
    name21: 'Version no.:',
    name22: 'File ID',
    name23: 'Vehicle model',
    name24: 'Version no.',
    name25: 'File name',
    name26: 'Type',
    name27: 'Size',
    name28: 'File path',
    name29: 'Creation time',
    name30: 'Merchant name:',
    name31: 'Controller version:',
    name32: 'Display version:',
    name33: 'IOT version:',
    name34: 'Vehicle model:',
    name35: 'Vehicle status:',
    name36: 'Add IOT no.',
    name37: 'Import IOT no.',
    name38: 'Vehicle no.',
    name39: 'Manufacturer>Merchant Name',
    name40: 'Vehicle MAC',
    name41: 'IOT no.',
    name42: 'Bind user account',
    name43: 'Controller version',
    name44: 'Test machine',
    name45: 'Normal',
    name46: 'Details',
    name47: 'Edit',
    name48: 'Model Name:',
    name49: 'Motor model:',
    name50: 'Battery signal:',
    name51: 'Vehicle ID',
    name52: 'Model Name',
    name53: 'Frame color',
    name54: 'Motor model',
    name55: 'Battery voltage',
    name56: 'Battery current',
    name57: 'Tire',
    name58: 'Version model:',
    name59: 'Version type:',
    name60: 'Upgrade type:',
    name61: 'Version type',
    name62: 'Version model',
    name63: 'Upgrade status',
    name64: 'Upgrade time',
    name65: 'Vehicle no.:',
    name66: 'Cycling no.:',
    name67: 'Fault status:',
    name68: 'Fault type:',
    name69: 'Report time:',
    name70: 'Cycling no.',
    name71: 'Fault type',
    name72: 'Fault status',
    name73: 'Report time',
    name74: 'Fault details',
    name75: 'Creator ID',
    name76: 'Modifier ID ',
    name77: 'Change time ',
    name78: 'Reviewer ID ',
    name79: 'Fault description',
    name80: 'Fault image',
    name81: 'No image info. available now',
    name82: 'Report Details',
    name83: 'Basic info.',
    name84: 'Report time:',
    name85: 'Other info.',
    name86: 'Speed:',
    name87: 'Longitude and latitude:',
    name88: 'Height:',
    name89: 'Controller voltage:',
    name90: 'Controller current:',
    name91: 'Controller temperature:',
    name92: 'Throttle voltage:',
    name93: 'Motor power:',
    name94: 'Cadence:',
    name95: 'Bluetooth connection status:',
    name96: 'GPS connection status:',
    name97: 'Display connection status:',
    name98: 'IOT No.:',
    name99: 'Test machine:',
    name100: 'Template download:',
    name101: 'Template download',
    name102: 'Upload IOT no.:',
    name103: 'Upload attachments',
    name104: 'Test',
    name105: 'Merchant name',
    name106: 'Display version',
    name107: 'IOT version',
    name108: 'Frame Five way No.',
    name109: 'Motor no.',
    name110: 'Remarks',
    name111: 'Transportation status',
    name112: 'Status',
    name113: 'Fault',
    name114: 'Unbind',
    name115: 'Bind',
    name116: 'Import Five way Code',
    name117: 'Transportation mode',
    name118: 'Version configuration',
    name119: 'Assign operators',
    name120: 'Vehicle model binding',
    name121: 'TTL mileage traveled:',
    name122: 'Max power:',
    name123: 'Mini power:',
    name124: 'Max voltage:',
    name125: 'Mini voltage:',
    name126: 'Max speed:',
    name127: 'Max Temp. of controller:',
    name128: 'Mini Temp. of controller:',
    name129: 'Fault time',
    name130: 'Corresponding code',
    name131: 'Fault definition',
    name132: 'No location info. available',
    name133: 'No fault data available now',
    name134: 'Voltage and current summary',
    name135: 'Temp. Summary',
    name136: 'Power/Speed Summary',
    name137: 'Controller temp.',
    name138: 'Motor temp.',
    name139: 'Battery temp.',
    name140: 'Power percentage',
    name141: 'Speed',
    name142: 'Battery voltage',
    name143: 'Battery current',
    name144: 'Temp.',
    name145: 'Report start time:',
    name146: 'Add Report',
    name147: 'Report start time',
    name148: 'Report end time',
    name149: 'Export Excel data',
    name150: 'Manufacturer:',
    name151: 'Report end time:',
    name152: 'Battery model:',
    name153: 'Battery model',
    name154: 'Battery capacity',
    name155: 'Sensor',
    name156: 'Allocation attribution',
    name157: 'Import Allocation attribution',
    name158: 'Import IOT',
    name159: 'Export vehicle info.',
    name160: 'Manufacturer/Merchant/Franchisee:',
    name161: 'Vehicle Details',
    name162: 'Modify notes',
    name163: 'Basic info. of vehicle',
    name164: 'Vehicle Code:',
    name165: 'Vehicle MAC:',
    name166: 'Storage time:',
    name167: 'Trajectory time:',
    name168: 'Heartbeat time:',
    name169: 'Longitude:',
    name170: 'Latitude:',
    name171: 'Height:',
    name172: 'Controller model:',
    name173: 'Controller temp. offset:',
    name174: 'Controller model',
    name175: 'Controller temp. offset',
    name176: 'Sensor:',
    name177: 'Tires:',
    name178: 'Battery capacity:',
    name179: 'Battery current:',
    name180: 'Battery voltage:',
    name181: 'Battery model:',
    name182: 'Motor model:',
    name183: 'Frame color:',
    name184: 'Model Name:',
    name185: 'New models added',
    name186: 'Vehicle condition picture:',
    name187: 'Equipment MGT images:',
    name188: 'Manufacturer/Merchant:',
    name189: 'Import Model',
    name190: 'Creator Name',
    name191: 'Creator ID',
    name192: 'Route book no.',
    name193: 'Creation time',
    name194: 'Update time',
    name195: 'Starting point',
    name196: 'Destination',
    name197: 'Distance (m)',
    name198: 'Road book type',
    name199: 'Personal Route book',
    name200: 'Official Route book',
    name201: 'Degree of difficulty',
    name202: 'Add Route book',
    name203: 'Starting point Add.:',
    name204: 'Destination Add.:',
    name205: 'Distance:',
    name206: 'Degree of Difficulty:',
    name207: 'Traffic:',
    name208: 'Heat consumption:',
    name209: 'Time (min):',
    name210: 'Cover:',
    name211: 'Trajectory set:',
    name212: 'Import vehicle info.',
    name213: 'Import product QC',
    name214: 'Production info.',
    name215: 'View vehicle info.',
    name216: 'Speed:',
    name217: 'Electricity level:',
    name218: 'Controller temp.:',
    name219: 'Motor temp.:',
    name220: 'Battery temp.:',
    name221: 'Voltage:',
    name222: 'Electric current:',
    name223: 'Status of vehicle lock:',
    name224: 'Unlock status',
    name225: 'Locking status',
    name226: 'Status:',
    name227: 'Fault',
    name228: 'Normal',
    name229: 'Vehicle info.',
    name230: 'Vehicle alarm info.',
    name231: 'Occurrence time',
    name232: 'Alarm status',
    name233: 'Changed',
    name234: 'Unchanged',
    name235: 'IOT version no.:',
    name236: 'IOT temp. display deviation value (℃):',
    name237: 'IOT temp. display alarm preset value (℃):',
    name238: 'Controller No.:',
    name239: 'Controller temp. display deviation value (℃):',
    name240: 'Controller temp. display alarm preset value (℃):',
    name241: 'Battery version:',
    name242: 'Battery No.:',
    name243: 'Battery temp. display deviation value (℃):',
    name244: 'Battery temp. display alarm preset value (℃):',
    name245: 'Motor version:',
    name246: 'Motor No.:',
    name247: 'Motor temp. display deviation value (℃):',
    name248: 'Motor temp. display alarm preset value (℃):',
    name249: 'Display No.:',
    name250: 'Display version：',
    name251: 'No',
    name252: 'Yes',
    name253: 'Delete',
    name254: 'IOT Details',
    name255: 'IOT Basic Info.',
    name256: 'Authentication username:',
    name257: 'Connection status:',
    name258: 'Port:',
    name259: 'Node:',
    name260: 'IP Add.:',
    name261: 'Heartbeat:',
    name262: 'Session creation time:',
    name263: 'Session expiration time:',
    name264: 'Connection time:',
    name265: 'No. of messages sent:',
    name266: 'Received message count:',
    name267: 'No. of received messages:',
    name268: 'Max unconfirmed packet count:',
    name269: 'Max flight window:',
    name270: 'Theme of IOT subscription',
    name271: 'IOT logs',
    name272: 'Vehicle IOT No.',
    name273: 'Product name',
    name274: 'Model',
    name275: 'Manufacturer or trademark',
    name276: 'Production plant and Add.',
    name277: 'Production date/manufacturing date',
    name278: 'Vehicle code',
    name279: 'Motor code',
    name280: 'Drive mode',
    name281: 'Max design speed',
    name282: 'Vehicle mass',
    name283: 'Motor power and rated voltage',
    name284: 'Battery type',
    name285: 'L/W/H(mm/mm/mm)',
    name286: 'Center distance between front and rear wheels (mm)',
    name287: 'Fixed position of nameplate',
    name288: 'Vehicle coding location',
    name289: 'Suggested service life',
    name290: 'Whether used for business activities like urban logistics or commercial leasing',
    name291: 'China Compulsory Certification (CCC) Certificate No.',
    name292: 'Engraved vehicle code',
    name293: 'Vehicle certificate photo',
    name294: 'Vehicle IOT No.:',
    name295: 'Vehicle code:',
    name296: 'Max current:',
    name297: 'Max temp. of motor:',
    name298: 'Maximum battery temperature:',
    name299: 'IoT temp. display deviation value (℃)',
    name300: 'IoT temp. display alarm preset value (℃)',
    name301: 'Controller temp. display deviation value (℃)',
    name302: 'Controller temp. display alarm preset value (℃)',
    name303: 'Deviation value of battery temp. display (℃)',
    name304: 'Battery temp. display alarm preset value (℃)',
    name305: 'Motor temp. display deviation value (℃)',
    name306: 'Motor temp. display alarm preset value (℃)',
    name307: 'Controller No.',
    name308: 'Battery No.',
    name309: 'Display No',
    name310: 'Sales status',
    name311: 'Sold',
    name312: 'Not sold',
    name313: 'Manufacturing date:',
    name314: 'CCC Certificate No.:',
    name315: 'Certificate expiration date:',
    name316: 'Product Qualification Certificate No.:',
    name317: 'Vehicle manufacturer:',
    name318: 'Production enterprise name:',
    name319: 'Vehicle Chinese Trademark:',
    name320: 'Vehicle English Trademark:',
    name321: 'Production enterprise Add.:',
    name322: 'Length, width, and height (mm):',
    name323: 'Overall quality of assembled E-bike(kg):',
    name324: 'Max design speed (km):',
    name325: 'Fixed position of nameplate:',
    name326: 'Location of  vehicle code on the frame:',
    name327: 'Range (km):',
    name328: 'Vehicle Outline Diagram Name:',
    name329: 'Battery type:',
    name330: 'Battery manufacturing enterprises:',
    name331: 'Battery capacity (Ah):',
    name332: 'Battery model:',
    name333: 'Battery weight (kg):',
    name334: 'Battery length, width, and height (mm):',
    name335: 'Center distance between front and rear wheels (mm):',
    name336: 'Driving mode:',
    name337: 'Electricity consumption per 100 KM:',
    name338: 'Motor manufacturing enterprises:',
    name339: 'Motor model:',
    name340: 'Motor type:',
    name341: 'Rated speed of motor:',
    name342: 'Rated voltage of motor (V):',
    name343: 'Rated continuous output power of motor (W):',
    name344: 'Controller manufacturer:',
    name345: 'Controller model:',
    name346: 'Controller undervoltage protection value (V):',
    name347: 'Controller overcurrent protection value (A):',
    name348: 'Front tire specifications:',
    name349: 'Rear tire specifications:',
    name350: 'Execution standard no.:',
    name351: 'Load capacity (kg):',
    name352: 'Battery nominal voltage (V):',
    name353: 'Motor nominal power (W):',
    name354: 'Brake type:',
    name355: 'Transmission specifications:',
    name356: 'IOT manufacturing enterprises:',
    name357: 'Edit vehicle model',
    name358: 'China Compulsory Certification (CCC) Certificate No.:',
    name359: 'CCC Certificate Status:',
    name360: 'Length(mm):',
    name361: 'Width(mm):',
    name362: 'Height(mm):',
    name363: 'Battery Length(mm):',
    name364: 'Battery Width(mm):',
    name365: 'Battery Height(mm):',
    name366: 'Product model:',
    name367: 'Production time:',
    name368: 'Sales status:',
    name369: 'Export of CCC materials',
    name370: 'Vehicle identification info.',
    name371: 'Vehicle parameter info.',
    name372: 'Certificate of conformity photo:',
    name373: 'Other photos:',
    name374: 'IOT model:',
    name375: 'Alarm time',
    name376: 'IOT software version no.',
    name377: 'IOT hardware version no.',
    name378: 'Offset',
    name379: 'Test vehicle:',
    name380: 'Pls select a vehicle',
    name381: 'Want to delete this vehicle?',
    name382: 'Select at most one vehicle',
    name383: 'It will change the transportation mode. Continue?',
    name384: 'Want to unbind the vehicle model ?',
    name385: 'Unbind successfully!',
    name386: 'Unbind cancelled',
    name387: 'Import IOT info.',
    name388: 'Five way code info. imported successfully',
    name389: 'Import IOT info. failed',
    name390: 'Import Five way Code Info.',
    name391: 'Import IOT info. successfully',
    name392: 'Pls select manufacturer and accessories',
    name393: 'Import certificate info. successfully',
    name394: 'Import certificate info. failed',
    name395: 'Import certificate info.',
    name396: 'Successfully imported vehicle info.',
    name397: 'Importing vehicle info. failed',
    name398: 'Import vehicle info.',
    name399: 'Importing vehicle factory info. failed',
    name400: 'Import vehicle factory info.',
    name401: 'Successfully imported vehicle factory info.',
    name402: 'Modify the factory info. of the vehicle',
    name403: 'Upload vehicle factory info. in EXCEL:',
    name404: 'Upload vehicle info. in EXCEL:',
    name405: 'Product Quality Certificate EXCEL Upload:',
    name406: 'Operator name:',
    name407: 'Vehicle model deviation',
    name408: 'Vehicle model EXCEL upload:',
    name409: 'Vehicle production info.',
    name410: 'Certificate of conformity image',
    name411: 'Wired upgrade',
    name412: 'APP upgrade',
    name413: 'Display',
    name414: 'Offline',
    name415: 'Upgrading',
    name416: 'Success',
    name417: 'Fail',
    name418: 'Upgrade package download failed',
    name419: 'Upgrade package verification error and external device communication failure',
    name420: 'Overvoltage protection',
    name421: 'Under voltage protection',
    name422: 'Controller power tube damage or overcurrent fault',
    name423: 'Blockage protection',
    name424: 'Motor Hall fault',
    name425: 'Motor phase line fault',
    name426: 'Throttle voltage too high',
    name427: 'Controller/motor over temp. protection',
    name428: 'Controller voltage fault',
    name429: 'Abnormal assistance fault',
    name430: 'MCU self-test fault',
    name431: 'Flying vehicle protection',
    name432: 'Pedal sensor fault',
    name433: 'Speed sensor fault',
    name434: 'Brake lever fault',
    name435: 'Exceed speed',
    name436: 'Battery communication fault',
    name437: 'Battery overheating',
    name438: 'Display communication fault',
    name439: 'Client ID',
    name440: 'No. of subscriptions',
    name441: 'IP Add.',
    name442: 'Connection status',
    name443: 'Connected',
    name444: 'Not connected',
    name445: 'OTA source:',
    name446: 'MAC Add.:',
    name447: 'Vehicle Debugging Report',
    name448: 'Add OTA file',
    name449: 'Edit OTA file',
    name450: 'Repair Order No.',
    name451: 'Operator',
    name452: 'Store add.',
    name453: 'Maintenance time',
    name454: 'Repair type',
    name455: 'No. before replacement',
    name456: 'No. after replacement',
    name457: 'Repair picture',
    name458: 'Actual sales time',
    name459: 'Invoice image',
    name460: "Failed to modify the vehicle's factory info.",
    name461: "Successfully modified the vehicle's factory info.",
    name462: 'Product Certification (CCC) Certificate Info.',
    name463: 'The manufacturer has not bound the vehicle model, making it difficult to accurately identify the controller offset value, which may result in errors in some data results. Pls ask the manufacturer to go to the vehicle model management to add the vehicle model and bind it to the vehicle model.',
    name464: 'IOT no. does not exist',
    name465: 'Starting time point',
    name466: 'End time point',
    name467: 'Repair type:',
    name468: 'Pls enter the vehicle model number',
    name469: 'Pls choose a carrier',
    name470: 'Pls select version number',
    name471: 'Pls select type',
    name472: 'Pls fill in the vehicle model number',
    name473: 'Pls enter the IOT number',
    name474: 'Pls enter the vehicle model name',
    name475: 'Pls enter the CCC certificate number',
    name476: 'Pls select a manufacturer',
    name477: 'Pls choose a start time',
    name478: 'Pls select an end time',
    name479: 'Pls enter MAC address',
    name480: 'Pls select the vehicle model',
    name481: 'Pls select a merchant',
    name482: 'Pls select a file',
    name483: 'Pls select a time',
    name484: 'Pls select a time within six hours',
    name485: 'Driving distance (m)',
    name486: 'Duration (s)',
    name487: 'Start Time',
    name488: 'End Time',
    name489: 'Details and Trajectory',
    name490: 'Repair time:',
    name491: 'Sales time:',
    name492: 'Vehicle MAC Number:',
    name493: 'Equipment ownership:',
    name494: 'Locking status:',
    name495: '(Negative values indicate battery charging)',
    name496: 'Status'
  },
  finance: {
    name1: 'Merchant Name:',
    name2: 'Billing time:',
    name3: 'Payment status:',
    name4: 'Manually generate bills',
    name5: 'Bill generation settings',
    name6: 'Billing time',
    name7: 'Manufacturer>Merchant Name',
    name8: 'No. of vehicles',
    name9: 'Unit price ($)',
    name10: 'Total ($)',
    name11: 'Remarks',
    name12: 'Payment status',
    name13: 'Payment voucher',
    name14: 'Payment Time',
    name15: 'Operation',
    name16: 'Edit',
    name17: 'Edit payment status',
    name18: 'Manufacturer>Merchant Name:',
    name19: 'Bill generation time:',
    name20: 'Remarks:',
    name21: 'Payment Time:',
    name22: 'Payment voucher upload:',
    name23: 'IOT device purchase order:',
    name24: 'Effective time:',
    name25: 'Vehicle Name:',
    name26: 'IMSI:',
    name27: 'SIM card no.:',
    name28: 'Vehicle no.',
    name29: 'IMSI',
    name30: 'SIM card no.',
    name31: 'Creation time',
    name32: 'Details',
    name33: 'Vehicle no.:',
    name34: 'Remaining data info. of SIM card',
    name35: '(Total traffic:',
    name36: ')',
    name37: 'Used traffic',
    name38: 'Remaining traffic',
    name39: 'Manufacturer>Merchant:',
    name40: 'Manufacturer>Merchant'
  },

  operate: {
    name1: 'Merchant Name:',
    name2: 'Search:',
    name3: 'App ID',
    name4: 'Manufacturer name',
    name5: 'App Name',
    name6: 'App icon',
    name7: 'Version no.',
    name8: 'Latest online time',
    name9: 'Operation',
    name10: 'Version List',
    name11: 'Newly added',
    name12: 'Version no.:',
    name13: 'Version status:',
    name14: 'Serial no.',
    name15: 'Version Id',
    name16: 'Version no.',
    name17: 'Version type',
    name18: 'Update type',
    name19: 'Version status',
    name20: 'Release time',
    name21: 'Update time',
    name22: 'Operation',
    name23: 'State',
    name24: 'Modify',
    name25: 'Delete',
    name26: 'Fill in version info.',
    name27: 'Version Description:',
    name28: 'Version type:',
    name29: 'Update type:',
    name30: 'Negligible',
    name31: 'Normal',
    name32: 'Force',
    name33: 'File:',
    name34: 'Click to upload',
    name35: 'Version Description:',
    name36: 'Modify version status',
    name37: 'Version no.:',
    name38: 'Status:',
    name39: 'Disable',
    name40: 'Test',
    name41: 'Release',
    name42: 'Login Account',
    name43: 'Merchant type',
    name44: 'Nickname',
    name45: 'User ID',
    name46: 'Head portrait',
    name47: 'Registration time',
    name48: 'Enable',
    name49: 'Associated vehicles',
    name50: 'Reset PWD',
    name51: 'Electronic fence name:',
    name52: 'Leave time:',
    name53: 'Electronic fence name',
    name54: 'Leave time ≥ 5 minutes',
    name55: 'Entry time',
    name56: 'Accumulated entry and exit time',
    name57: 'Trajectory details',
    name58: 'Fence no.:',
    name59: 'Fence name:',
    name60: 'Fence type:',
    name61: 'Fence no.',
    name62: 'Fence name',
    name63: 'Fence type',
    name64: 'Drawing type',
    name65: 'Activity area',
    name66: 'Prohibited areas',
    name67: 'Polygon',
    name68: 'Coordinate point editing',
    name69: 'Add new area fence',
    name70: 'Edit area fence',
    name71: 'Drawing type:',
    name72: 'Map type:',
    name73: 'Google Maps',
    name74: 'Baidu Maps',
    name75: 'VCL',
    name76: 'Start',
    name77: 'Path replay',
    name78: 'Pause playback',
    name79: 'Electronic Fence - Vehicle List',
    name80: 'Search',
    name81: 'Import',
    name82: 'IOT Add',
    name83: 'Electronic fence - vehicle list import',
    name84: 'VCL：',
    name85: 'Coordinates saved successfully!',
    name86: 'Order No.:',
    name87: 'User ID:',
    name88: 'Serial no.:',
    name89: 'Payment platform:',
    name90: 'Time:',
    name91: 'Order No.',
    name92: 'Serial no.',
    name93: 'User ID',
    name94: 'Transaction amount',
    name95: 'Payment platform',
    name96: 'Transaction voucher',
    name97: 'Trading Hours',
    name98: 'All',
    name99: 'Alipay',
    name100: 'WeChat',
    name101: 'PayPal',
    name102: 'Application No.:',
    name103: 'Applicant ID:',
    name104: 'Audit status:',
    name105: 'Application No.',
    name106: 'Applicant ID',
    name107: 'Refund amount',
    name108: 'Application Time',
    name109: 'Application status',
    name110: 'Application results',
    name111: 'Details',
    name112: 'Recheck',
    name113: 'First check',
    name114: 'Reason for refund',
    name115: 'Audit No.:',
    name116: 'Application Time:',
    name117: 'Auditor ID:',
    name118: 'Review time:',
    name119: 'Review reason :',
    name120: 'Review result:',
    name121: 'Refund voucher (picture)',
    name122: 'Refund details',
    name123: ' Review info.',
    name124: 'Will it enter the recheck process?',
    name125: 'Will it enter the first check process?',
    name126: 'Parking Area',
    name127: 'App ID:',
    name128: 'App Name:',
    name129: 'Merchant List',
    name130: 'New Version',
    name131: 'Name of submitter:',
    name132: 'Feedback Title:',
    name133: 'Feedback status:',
    name134: 'Presenter',
    name135: 'Feedback Title',
    name136: 'Feedback location',
    name137: 'Feedback recipient email',
    name138: 'Feedback Time',
    name139: 'Feedback status',
    name140: 'Customized App Info.',
    name141: 'Personal General App Info.',
    name142: 'Add APP info.',
    name143: 'Edit APP info.',
    name144: 'App icon:',
    name145: 'Add a general personal app merchant',
    name146: 'E-commerce Center',
    name147: 'User Notice',
    name148: 'Privacy Policy',
    name149: 'Logo settings',
    name150: 'Preview',
    name151: 'E-commerce website:',
    name152: 'User Notice Preview',
    name153: 'Privacy Policy Preview',
    name154: 'Pls enter the link add.',
    name155: 'Login Name/Email',
    name156: 'Nickname',
    name157: 'Account type',
    name158: 'User ID',
    name159: 'cell-phone no.',
    name160: 'Connect time',
    name161: 'Unbind',
    name162: 'Push Message',
    name163: 'Push Message:',
    name164: 'New PWD:',
    name165: 'Confirm new PWD:',
    name166: 'Road book editor',
    name167: 'Road book usage',
    name168: 'Cycling mode',
    name169: 'Looking for a car',
    name170: 'Alarm settings',
    name171: 'Pls select region',
    name172: 'Pls enter the fence name',
    name173: 'Pls select the type of fence',
    name174: 'Pls select the drawing type',
    name175: 'Pls select IOT encoding',
    name176: 'Feedback Content',
    name177: 'Feedback image',
    name178: 'Version Name:',
    name179: 'Download page link',
    name180: 'Copy the download page link',
    name181: 'Version Name'
  },

  manage: {
    name1: 'Search:',
    name2: 'Status:',
    name3: 'New User',
    name4: 'Login Account',
    name5: 'User Name',
    name6: 'Role',
    name7: 'Telephone',
    name8: 'Mailbox',
    name9: 'Latest editing time',
    name10: 'Last login time',
    name11: 'Last login IP',
    name12: 'State',
    name13: 'Enable',
    name14: 'Disable',
    name15: 'Operation',
    name16: 'Binding roles',
    name17: 'Edit',
    name18: 'Delete',
    name19: 'Add system user',
    name20: 'Login account:',
    name21: 'Password:',
    name22: 'Full name:',
    name23: 'Nickname:',
    name24: 'Telephone:',
    name25: 'Role:',
    name26: 'Mailbox:',
    name27: 'Role Name:',
    name28: 'Role Name',
    name29: 'Permission',
    name30: 'Add new role',
    name31: 'Add Identity',
    name32: 'Identity Name:',
    name33: 'Is it enabled:',
    name34: 'Open',
    name35: 'Close',
    name36: 'Permission:',
    name37: 'Permission Name:',
    name38: 'Permission Name',
    name39: 'Interface path',
    name40: 'Front end permissions',
    name41: 'Page routing',
    name42: 'Submenus',
    name43: 'Add rules',
    name44: 'Type:',
    name45: 'Interface',
    name46: 'Menu',
    name47: 'Interface Chinese Name:',
    name48: 'Parent level classification:',
    name49: 'Add permissions',
    name50: 'Request method:',
    name51: 'Interface add.:',
    name52: 'Routing add.:',
    name53: 'Permission identifier:',
    name54: 'Sort by:',
    name55: 'Icon:',
    name56: 'Note: Upload icon, 200 * 200 pixels. Only one image can be uploaded',
    name57: 'Hide menu:',
    name58: 'Time:',
    name59: 'Time',
    name60: 'Export',
    name61: 'Operation account ID',
    name62: 'Operate account',
    name63: 'Operation type',
    name64: 'Operation content',
    name65: 'Manufacturer name:',
    name66: 'Manufacturer code',
    name67: 'Manufacturer name',
    name68: 'Creation time',
    name69: "Manufacturer's order QTY",
    name70: 'No. of vehicle models',
    name71: 'No. of associated merchants',
    name72: 'Contact info.',
    name73: 'Manufacturer account',
    name74: 'Add',
    name75: 'Manufacturer code:',
    name76: 'Contacts:',
    name77: 'Contact info.:',
    name78: 'Remarks:',
    name79: 'Merchant Name',
    name80: 'Merchant type',
    name81: 'No. of merchant users',
    name82: 'Remarks',
    name83: 'IOT charging status',
    name84: 'Merchant account',
    name85: 'Add merchant list',
    name86: 'Merchant Name:',
    name87: 'Merchant type:',
    name88: 'Get into',
    name89: 'Add merchant user',
    name90: 'Franchisee Name:',
    name91: 'Franchisee name',
    name92: 'No. of merchant vehicles',
    name93: 'Franchise account',
    name94: 'Edit system user',
    name95: 'Menu Chinese Name:',
    name96: 'Edit Identity',
    name97: 'Add manufacturer List',
    name98: 'Edit manufacturer List',
    name99: 'Add Manufacturer User',
    name100: 'Edit Manufacturer User',
    name101: 'Edit Merchant User',
    name102: 'Add Franchisee Users',
    name103: 'Edit Franchisee Users',
    name104: 'Interface English Name:',
    name105: 'Menu English Name:',
    name106: 'All permissions',
    name107: 'Platform:',
    name108: "Manufacturer's App",
    name109: 'Customer service type:',
    name110: 'Content:',
    name111: 'Website and Account',
    name112: 'Account Name:',
    name113: 'Website:',
    name114: 'Name:',
    name115: 'Permission configuration',
    name116: 'Li Dian',
    name117: 'Manufacturer',
    name118: 'Brand Merchant',
    name119: 'Brand merchant franchisee',
    name120: 'Shared Merchant',
    name121: 'Rental merchants',
    name122: 'Shared Franchisees',
    name123: 'Leasing franchisees',
    name124: 'H5 permission',
    name125: 'MGT backend',
    name126: 'Want to delete this user?',
    name127: 'Want to ban vendor app permissions?',
    name128: 'Want to enable vendor app permissions?',
    name129: 'Vehicle seller',
    name130: 'Detailed add.',
    name131: 'Contact Number',
    name132: 'Detailed add.:',
    name133: 'Contact No.:',
    name134: 'House no., for example: Room 102 on the 1st floor',
    name135: 'Add franchisee list',
    name136: 'Edit the list of franchisees',
    name137: 'Want to delete this franchisee?',
    name138: 'Franchisee',
    name139: 'Workshop APP',
    name140: 'Is the workshop app permission banned?',
    name141: 'Do you want to enable workshop app permissions?'
  },

  public: {
    name1: 'Pls Select',
    name2: 'Merchant Type',
    name3: 'Query',
    name4: 'Reset',
    name5: 'Pls Input',
    name6: 'Select date and time',
    name7: 'Log out',
    name8: 'Lidian Cloud IOT Platform',
    name9: 'To',
    name10: 'Start Date',
    name11: 'End Date',
    name12: 'upload',
    name13: 'Submit',
    name14: 'Cancel',
    name15: 'Start month',
    name16: 'End month',
    name17: 'Sent Successfully',
    name18: 'Modified Successfully',
    name19: 'All',
    name20: 'Open',
    name21: 'Close',
    name22: 'Cancellation',
    name23: 'Prompt',
    name24: 'Are you sure to delete the current data?',
    name25: 'Sure',
    name26: 'Confirm PWD',
    name27: 'Email format incorrect',
    name28: 'Pls enter a nickname or account',
    name29: 'Pls enter as follows:',
    name30: 'Delete successfully!',
    name31: 'Cancelled deletion',
    name32: 'Are you sure to submit?',
    name33: 'Submitted cancelled',
    name34: 'Cancelled',
    name35: 'Uploading, pls wait ..',
    name36: 'The size of the uploaded file cannot exceed 10MB!',
    name37: 'Download and view failure reason',
    name38: 'Pls select the attachment',
    name39: 'No data',
    name40: 'Are you sure to delete this data?',
    name41: 'Added successfully',
    name42: 'Upload successfully',
    name43: 'Select date',
    name44: 'Loading..',
    name45: 'Pls select any level',
    name46: 'Failed to import vehicle model information?',
    name47: 'Vehicle model import information',
    name48: 'Successfully imported vehicle model information',
    name49: 'Last 6 hours',
    name50: 'Last hour',
    name51: 'Last login time',
    name52: 'Are you sure to delete the current vehicle?',
    name53: 'Electronic fence - Import IOT information',
    name54: 'Abnormal positioning information',
    name55: 'Single battery voltage',
    name56: 'Data acquisition time:',
    name57: 'Single battery voltage (V)',
    name58: 'Serial Number',
    name59: 'Beidou positioning anomaly',
    name60: 'Abnormal'
  },
  account: {
    name1: 'Change email add.',
    name2: 'User defined message',
    name3: 'User defined time zone',
    name4: 'Confirm',
    name5: 'My Account',
    name6: 'Language switching',
    name7: 'Pls enter a new email address',
    name8: 'Confirm',
    name9: 'Cancel',
    name10: 'Simplified Chinese',
    name11: 'English',
    name12: 'My',
    name13: 'No sales records available at the moment',
    name14: 'Add sales records',
    name15: 'No maintenance records available at the moment',
    name16: 'Add maintenance records',
    name17: 'Photo recognition',
    name18: 'Sales Time',
    name19: 'Upload invoice',
    name20: 'Do you want to submit sales records?',
    name21: 'Please click on the three dots in the upper right corner, and then click to re-enter the mini program. When taking photos for recognition, please click to allow the use of the camera',
    name22: 'Pls enter the vehicle number',
    name23: 'View Invoice',
    name24: 'There is no more data available',
    name25: 'no.',
    name26: 'Photos of maintenance site',
    name27: '(Add up to 9 sheets)',
    name28: 'no.:',
    name29: 'Log in',
    name30: 'Hello, welcome to log in',
    name31: 'Pls enter your phone/email',
    name32: 'Register account',
    name33: 'Switch',
    name34: 'Phone registration',
    name35: 'Email registration',
    name36: 'Name',
    name37: 'Nickname',
    name38: 'Store address',
    name39: 'Return to login',
    name40: 'Agree and read',
    name41: '《User Agreement and Privacy Policy》',
    name42: 'User Agreement and Privacy Policy',
    name43: 'Set login password',
    name44: 'After setting the password, you can use the new password to log in',
    name45: 'Phone',
    name46: 'Email',
    name47: 'Change Time Zone',
    name48: 'Pls check the User Agreement and Privacy Policy'
  },
  screen: {
    name1: 'Location',
    name2: 'Title:',
    name3: 'Title',
    name4: 'Su ICP No. 2023025954-3',
    name5: 'Pls enter push information',
    name6: 'Pls enter a new password',
    name7: 'Pls enter the new password again',
    name8: 'Pls enter your account',
    name9: 'Are you sure to unbind the vehicle?',
    name10: 'Password changed successfully',
    name11: 'Pls select the users to be pushed',
    name12: 'Push successful',
    name13: 'Location:',
    name14: 'Do you want to delete this account?',
    name15: 'Pls enter the manufacturer name',
    name16: 'Do you want to delete this manufacturer?',
    name17: 'Should the manufacturer be banned?',
    name18: 'Do you want to enable this vendor?',
    name19: 'Pls enter your identity name',
    name20: 'Pls choose whether to enable it or not',
    name21: 'Administrators',
    name22: 'Salesman',
    name23: 'Do you want to delete this role?',
    name24: 'Pls choose a platform',
    name25: 'Pls select a role',
    name26: 'Pls search and select an address',
    name27: 'Pls enter your contact phone number',
    name28: 'Pls enter the name of the franchisee',
    name29: 'Pls select a franchisee',
    name30: 'Pls enter the merchant name',
    name31: 'Pls select an address',
    name32: 'Pls select merchant type',
    name33: 'Should this merchant be banned?',
    name34: 'Do you want to activate this merchant?',
    name35: 'Level 1',
    name36: 'Level 2',
    name37: 'Level 3',
    name38: 'Button',
    name39: 'Pls enter the Chinese name of the menu',
    name40: 'Pls enter the English name of the menu',
    name41: 'Pls enter the routing address',
    name42: 'Do you want to delete this data?',
    name43: 'Do you want to disable this permission rule?',
    name44: 'Do you want to enable this permission rule?',
    name45: 'System Log',
    name46: 'Change phone number',
    name47: 'Pls enter a new phone number',
    name48: 'Email modification successful',
    name49: 'Mobile number successfully modified',
    name50: 'Newly proposed',
    name51: 'Reviewed',
    name52: 'Processing',
    name53: 'Refused',
    name54: 'Closed',
    name55: 'Feedback Details',
    name79: 'Cancel',
    name95: 'Add',
    name167: 'Vehicle Distribution Fence',
    name169: 'Coordinates',
    name170: 'Longitude',
    name171: 'Latitude',
    name110: 'Operation',
    name111: 'Modify',
    name112: 'Delete',
    name168: 'Save',
    name172: 'Save Coordinates',
    name173: 'Pls save edited coordinates first',
    name174: 'New Coordinates',
    name175: 'Pls save edited coordinates first'
  },
  dataSummary: {
    name1: 'No. of apps',
    name2: 'Subscriber no.',
    name3: 'No. of new users this month',
    name4: 'MGT system login status',
    name5: 'System function usage'
  }
}
